import { __extends } from "tslib";
import { SendMessagesRequest, SendMessagesResponse } from "../models/models_1";
import { deserializeAws_restJson1SendMessagesCommand, serializeAws_restJson1SendMessagesCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var SendMessagesCommand = /** @class */ (function (_super) {
    __extends(SendMessagesCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function SendMessagesCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    SendMessagesCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "PinpointClient";
        var commandName = "SendMessagesCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: SendMessagesRequest.filterSensitiveLog,
            outputFilterSensitiveLog: SendMessagesResponse.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    SendMessagesCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1SendMessagesCommand(input, context);
    };
    SendMessagesCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1SendMessagesCommand(output, context);
    };
    return SendMessagesCommand;
}($Command));
export { SendMessagesCommand };
//# sourceMappingURL=SendMessagesCommand.js.map